import React, { useState } from "react";
import { Link } from "react-router-dom";
import { config } from "../../config/config";

import {
	MDBContainer,
	MDBNavbar,
	MDBNavbarToggler,
	MDBIcon,
	MDBNavbarNav,
} from "mdb-react-ui-kit";

function Header() {
	const [isOpen, setIsOpen] = useState(false);
	const toggleCollapse = () => {
		if (isOpen) {
			setIsOpen(false);
		} else {
			setIsOpen(true);
		}
	};
	return (
		<div>
			<MDBNavbar expand="lg" dark bgColor="primary">
				<MDBContainer>
					<Link className="navbar-brand" to="/">
						{config.site_title}
					</Link>

					<MDBNavbarToggler
						aria-controls="navbarSupportedContent"
						aria-expanded="false"
						aria-label="Toggle navigation"
						onClick={toggleCollapse}
					>
						<MDBIcon icon="bars" fas />
					</MDBNavbarToggler>

					<div
						className={`collapse navbar-collapse ${
							isOpen && "show"
						}`}
						id="navbarSupportedContent"
					>
						<MDBNavbarNav
							right
							className=" mb-2 mb-lg-0"
							onClick={toggleCollapse}
						>
							<li className="nav-item">
								<Link
									className={`nav-link ${
										window.location.pathname === "/"
											? "active"
											: ""
									}`}
									aria-current="page"
									to="/"
								>
									Home
								</Link>
							</li>
							<li className="nav-item">
								<Link
									className={`nav-link ${
										window.location.pathname === "/historie"
											? "active"
											: ""
									}`}
									aria-current="page"
									to="/historie"
								>
									Historie
								</Link>
							</li>
							<li className="nav-item">
								<Link
									className={`nav-link ${
										window.location.pathname === "/pages"
											? "active"
											: ""
									}`}
									to="/pages"
								>
									Pages
								</Link>
							</li>
							<li className="nav-item">
								<Link
									className={`nav-link ${
										window.location.pathname ===
										"/categories"
											? "active"
											: ""
									}`}
									to="/categories"
								>
									Categories
								</Link>
							</li>
							<li className="nav-item">
								<Link
									className={`nav-link ${
										window.location.pathname === "/search"
											? "active"
											: ""
									}`}
									to="/search"
								>
									Search
								</Link>
							</li>
						</MDBNavbarNav>
					</div>
				</MDBContainer>
			</MDBNavbar>
		</div>
	);
}
export default Header;
